import { Typography, TypographyProps } from '@mui/material'
import React from 'react'
interface Props extends TypographyProps {

}
const Span:ReactFC<Props> = ({ children, ...typographyProps }) => {
  return (
    <Typography
      component='span'
      {...typographyProps}
    >
      {children}
    </Typography>
  )
}
export default Span
